// extracted by mini-css-extract-plugin
export default {"overlay":"LoadingOverlay_overlay__R9YhW","progress":"LoadingOverlay_progress__vLxHb"};